/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetTimecardBreakDefinitionRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {BatchTimecardBreakDefinitionResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const batchGetTimecardBreakDefinition = (request: BatchGetTimecardBreakDefinitionRequest, options?: CashRequestOptions) => post<BatchGetTimecardBreakDefinitionRequest, BatchTimecardBreakDefinitionResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/BatchGetTimecardBreakDefinition", request, {...options, rejectOnError: true })